import { Info } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { Theme } from "@mui/material/styles";

import Box from "../Box";
import Typography from "../Typography";

import { box, typography } from "./styles";

interface IProps {
    label: string;
    required?: boolean;
    tooltip?: string;
    isError: boolean;
}

const Label = ({ label, required, tooltip, isError }: IProps) => {
    return (
        <Box
            sx={(theme: Theme) =>
                box(theme, {
                    gap: 1,
                    flexDirection: "row",
                    height: "unset",
                })
            }
        >
            <Typography sx={(theme: Theme) => typography(theme, { fontWeight: 500, isError })}>
                {label} {required && "(*)"}
            </Typography>
            {tooltip && (
                <Tooltip arrow title={tooltip} aria-label={tooltip} placement="right">
                    <Info />
                </Tooltip>
            )}
        </Box>
    );
};

export default Label;
